import React, { useState } from 'react'
import ContentLoader from 'react-content-loader'
import { LoaderContainer, PlaceholderData } from './mixins'

const FichaAvisoPlaceholderMobile = () => {
  const [wrapperWidth, setWrapperWidth] = useState(0)
  return (
    <LoaderContainer ref={node => node && setWrapperWidth(node.offsetWidth)}>
      {/** DESCRIPTION */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={670}
          viewBox={`0 0 ${wrapperWidth} 670`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="16" y="14" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="16" rx="4" ry="4" width={wrapperWidth * 0.4786} height="16" />
          <rect x="16" y="50" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="52" rx="4" ry="4" width={wrapperWidth * 0.3445} height="16" />

          <rect x="16" y="84" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="116" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="148" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="180" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="212" rx="4" ry="4" width={wrapperWidth * 0.6768} height="16" />
          <rect x="16" y="252" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="280" rx="4" ry="4" width={wrapperWidth * 0.2134} height="16" />
          <rect x="16" y="324" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="356" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="388" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="420" rx="4" ry="4" width={wrapperWidth * 0.7987} height="16" />

          {/** DATA */}
          <path d={`M 16 452 h ${wrapperWidth * 0.9024} v 1 H 16 z`} />
          <rect x="16" y="468" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="470" rx="4" ry="4" width={wrapperWidth * 0.4115} height="16" />
          <rect x="16" y="500" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="502" rx="4" ry="4" width={wrapperWidth * 0.1737} height="16" />
          <rect x="16" y="532" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="534" rx="4" ry="4" width={wrapperWidth * 0.3445} height="16" />
          <rect x="16" y="564" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="566" rx="4" ry="4" width={wrapperWidth * 0.3445} height="16" />
          <rect x="16" y="596" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="598" rx="4" ry="4" width={wrapperWidth * 0.2683} height="16" />
          <rect x="16" y="628" rx="4" ry="4" width="20" height="20" />
          <rect x="44" y="630" rx="4" ry="4" width={wrapperWidth * 0.3445} height="16" />
        </ContentLoader>
      </PlaceholderData>
      {/** COMPANY DATA */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={128}
          viewBox={`0 0 ${wrapperWidth} 128`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="16" y="16" rx="4" ry="4" width="184" height="16" />
          <rect x="16" y="72" rx="4" ry="4" width="184" height="16" />
          <rect x="16" y="40" rx="4" ry="4" width="77" height="16" />
          <rect x="16" y="96" rx="4" ry="4" width="77" height="16" />
        </ContentLoader>
      </PlaceholderData>
      {/** COMPANY BUTTON */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height="48"
          viewBox={`0 0 ${wrapperWidth} 48`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
        </ContentLoader>
      </PlaceholderData>
      {/** COMPANY DESCRIPTION */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={176}
          viewBox={`0 0 ${wrapperWidth} 176`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="16" y="16" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="80" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="144" rx="4" ry="4" width={wrapperWidth * 0.6768} height="16" />
          <rect x="16" y="48" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
          <rect x="16" y="112" rx="4" ry="4" width={wrapperWidth * 0.9024} height="16" />
        </ContentLoader>
      </PlaceholderData>
      {/** RECOMMENDED JOBS */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={328}
          viewBox={`0 0 ${wrapperWidth} 328`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <path d="M 0 0 h 6 v 328 H 0 z" />
          <rect x="16" y="12" rx="4" ry="4" width="68" height="44" />
          <rect x="96" y="18" rx="2" ry="2" width="220" height="8" />
          <rect x="96" y="42" rx="2" ry="2" width="157" height="8" />
          <rect x={wrapperWidth * 0.6036} y="296" rx="4" ry="4" width={wrapperWidth * 0.3597} height="20" />
          <rect x="36" y="303" rx="2" ry="2" width="86" height="6" />
          <rect x="16" y="298" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="249" rx="2" ry="2" width="144" height="8" />
          <rect x="16" y="245" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="274" rx="2" ry="2" width="111" height="8" />
          <rect x="16" y="270" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="224" rx="2" ry="2" width="99" height="8" />
          <rect x="16" y="220" rx="4" ry="4" width="16" height="16" />
          <rect x="16" y="112" rx="2" ry="2" width="300" height="9" />
          <rect x="16" y="185" rx="2" ry="2" width="300" height="9" />
          <rect x="16" y="148" rx="2" ry="2" width="300" height="9" />
          <rect x="16" y="130" rx="2" ry="2" width="300" height="9" />
          <rect x="16" y="203" rx="2" ry="2" width="242" height="9" />
          <rect x="16" y="167" rx="2" ry="2" width="300" height="9" />
          <rect x="16" y="68" rx="2" ry="2" width={wrapperWidth * 0.9146} height="12" />
          <rect x="16" y="88" rx="2" ry="2" width={wrapperWidth * 0.6311} height="12" />
        </ContentLoader>
      </PlaceholderData>
    </LoaderContainer>
  )
}

export default FichaAvisoPlaceholderMobile
